module.exports = __webpack_public_path__ + "img/c5201809.4de454f6.jpg";